<template lang="pug">
  #app
    localization
</template>

<script>
import { mapGetters } from 'vuex'
import Localization from '@/localization'
import authType from '@/store/types/auth'

export default {
  name: 'app',
  components: { Localization },
  computed: {
    ...mapGetters({
      token: authType.getters.getToken,
    }),
    nextRoute() {
      return this.$route.query.redirect || '/'
    },
  },
  watch: {
    token(value) {
      if (!value) {
        this.$router.push('/system/login')
      }
    },
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
}
</script>

<style lang="scss">
  @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
  // @import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham-dark.css";
  // @import "../node_modules/ag-grid-community/dist/styles/ag-theme-blue.css";
  // @import "../node_modules/ag-grid-community/dist/styles/ag-theme-bootstrap.css";
  // @import "../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css";
  // @import "../node_modules/ag-grid-community/dist/styles/ag-theme-material.css";
  // @import "../node_modules/ag-grid-community/dist/styles/ag-theme-dark.css";
  .ag-theme-balham .ag-paging-panel{
    border: 1px solid #BDC3C7;
    background-color: #f5f7f7;
  }
</style>
